



























import type { PropType } from '@vue/composition-api';
import { computed, defineComponent } from '@vue/composition-api';
import type { DsrDirectory } from '@getaccept/lib-shared/src/library/types/dsr-directory';
import DateCell from '@getaccept/lib-shared/src/library/components/DateCell.vue';
import DirectoryName from '@getaccept/lib-shared/src/library/components/DirectoryName.vue';
import { LibraryHelper } from '@getaccept/lib-shared/src/library/helpers/library.helper';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';

export default defineComponent({
  name: 'DirectoryRow',
  components: {
    DirectoryName,
    DateCell,
  },
  props: {
    directory: {
      type: Object as PropType<DsrDirectory>,
      required: true,
    },
    selectable: {
      type: Boolean,
    },
    selected: {
      type: Boolean,
    },
    isContentPlaceholder: {
      type: Boolean,
    },
    indeterminate: {
      type: Boolean,
    },
    alreadySelected: {
      type: Boolean,
    },
  },
  setup(props) {
    const selectableTooltip = computed(() => {
      if (!props.selectable) {
        return t('dr_no_resources_in_directory');
      }
      if (props.alreadySelected) {
        return t('content_resource_directory_already_added');
      }
      return '';
    });
    return {
      convertToISODate: LibraryHelper.convertToISODate,
      t,
      selectableTooltip,
    };
  },
});
